import { topshotsAPI } from '../../app/api';

import { ICoupon, PagedRequest, PagedResponse } from '@topshots/core-models';

const eventsApi = topshotsAPI.injectEndpoints({
  endpoints: (build) => ({
    getCoupons: build.query<
      PagedResponse<ICoupon[]>,
      PagedRequest & { search?: string }
    >({
      query: (request) => ({
        url: 'coupons',
        method: 'GET',
        params: request,
      }),
      providesTags: (result, error, page) =>
        result
          ? [
              // Provides a tag for each enquiry in the current page,
              // as well as the 'PARTIAL-LIST' tag.
              ...result.data.map(({ _id }) => ({
                type: 'Coupons' as const,
                id: _id.toString(),
              })),
              { type: 'Coupons', id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'Coupons', id: 'PARTIAL-LIST' }],
    }),

    getCoupon: build.query<ICoupon, string>({
      query: (id) => ({
        url: `coupons/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, page) => [
        { type: 'Coupons' as const, id: result?._id.toString() },
      ],
    }),
    createCoupon: build.mutation<ICoupon, Partial<ICoupon>>({
      query: (request) => ({
        url: `coupons`,
        method: 'POST',
        body: request,
      }),
      invalidatesTags: (result, error, product) => [
        { type: 'Coupons', id: 'PARTIAL-LIST' },
        { type: 'Coupons', id: result?._id.toString() },
      ],
    }),
    updateCoupon: build.mutation<
      ICoupon,
      { id: string; data: Partial<ICoupon> }
    >({
      query: (request) => ({
        url: `coupons/${request.id}`,
        method: 'PUT',
        body: request.data,
      }),
      invalidatesTags: (result, error, product) => [
        { type: 'Coupons', id: 'PARTIAL-LIST' },
        { type: 'Coupons', id: result?._id.toString() },
      ],
    }),
    deleteCoupon: build.mutation<ICoupon, string>({
      query: (id) => ({
        url: `coupons/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, product) => [
        { type: 'Coupons', id: 'PARTIAL-LIST' },
        { type: 'Coupons', id: result?._id.toString() },
      ],
    }),
  }),
});

export const {
  useGetCouponQuery,
  useGetCouponsQuery,
  useCreateCouponMutation,
  useDeleteCouponMutation,
  useUpdateCouponMutation,
} = eventsApi;
